/* eslint-disable @typescript-eslint/no-explicit-any */
export default function animate(data: any, theme: any) {
  if (data.type === 'line' || data.type === 'area') {
    data.element.animate({
      d: {
        begin: 350 * data.index,
        dur: 350,
        from: data.path.clone().scale(1, 0).translate(0, data.chartRect.height()).stringify(),
        to: data.path.clone().stringify(),
        easing: theme.transitions.easing.easeOut,
      },
    });
  }
}
